<template>
    <div>
        <b-card header="heder">
            <template v-slot:header>
                <div class="d-flex justify-content-between">
                    <h3 class="dashboard-title">Bot list</h3>
                    <div class="d-flex justify-content-end">
                        <b-form inline>
                            <label for="level-list" class="mr-2 ml-2">그룹</label>
                            <b-form-select id="level-list" @change="reloadPeonList($event)" v-model="selectedGroup"
                                           :options="groupOptions" size="sm" class=""></b-form-select>
                            <button type="button" class="ml-5 btn btn-blue btn-sm" @click="reloadPeonList()">Reload</button>
                        </b-form>
                    </div>
                </div>
            </template>

            <b-tabs>
                <b-tab id="botlist2" title="List" active title-item-class="dashboard-tab">
                    <b-container class="dashboard-list">
                        <template v-for="start in peonSlicedIndexes">
                            <b-row>
                                <template v-for="(peon, index) in peonSlicedList(start, start + 6)">
                                    <b-col cols="2" v-b-tooltip.hover :title="peon.deviceId"
                                           @click="showDetails(peon.deviceId)">
                                        <div class="dashboard-botlist pt-2 pb-1">
                                            <div v-if="peonStatus(peon.deviceId) === 'Running'" class="text-uppercase">
                                                <img src="../assets/images/gear_run.svg" alt="running" class="run-bot">
                                            </div>
                                            <div v-else-if="peonStatus(peon.deviceId) === 'Ready'" class="text-uppercase">
                                                <img src="../assets/images/gear_ready.svg" alt="ready" class="ready-bot">
                                            </div>
                                            <div v-else class="text-uppercase">
                                                <img src="../assets/images/disconnected.svg" alt="disconnected"
                                                     class="disconnected-bot">
                                            </div>
                                            <b>{{ peon.alias }}</b>
                                            <!-- <b>{{ start }}</b> -->
                                        </div>
                                    </b-col>
                                </template>
                            </b-row>
                        </template>
                    </b-container>
                </b-tab>

                <b-tab v-if="false" id="botlist" title="Details" title-item-class="dashboard-tab">
                    <div class="card-body">
                        <table class="table table-bordered table-hover table-striped shadow-sm">
                            <thead class="dashboard-header">
                                <tr class="text-center">
                                    <th>Alias</th>
                                    <th>Tick</th>
                                    <th>Status</th>
                                    <th>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(peon, index) in peonList">
                                    <tr>
                                        <td rowspan='2' class="align-middle" width="25%">
                                            <a href="#" @click="showDetails(peon.deviceId)" class="bot-detail">
                                                <div class="d-flex flex-row">
                                                    <div class="">
                                                        <div v-if="peonStatus(peon.deviceId) === 'Running'">
                                                            <img src="../assets/images/gear_run.svg" alt="run"
                                                                 class="run-bot">
                                                        </div>
                                                        <div v-else-if="peonStatus(peon.deviceId) === 'Ready'">
                                                            <img src="../assets/images/gear_ready.svg" alt="run"
                                                                 class="ready-bot">
                                                        </div>
                                                        <div v-else>
                                                            <img src="../assets/images/disconnected.svg" alt="disconnected"
                                                                 class="disconnected-bot">
                                                        </div>
                                                    </div>
                                                    <div class="ml-3">
                                                        <b>{{ peon.alias }}</b>
                                                        <br>
                                                        ( {{ heartBeatTimestamp(peon.deviceId) }} )
                                                    </div>
                                                </div>
                                            </a>

                                        </td>
                                        <td class="text-center">{{ peon.tick }}</td>
                                        <td>
                                            <div>
                                                <div :id="'bot-status' + index">

                                                    <my-canvas class="bot-status-chart" :id="'tooltip' + index">
                                                        <my-box2 v-for="(obj, index) in [peon.cpuUsage, Math.round(peon.memoryUsage / peon.totalMemory * 100), Math.round(peon.diskUsage / peon.totalDisk * 100)]"
                                                                 :x1="0" :x2="obj" :y1="((index / 3) * 100)"
                                                                 :y2="((index / 3) * 100) + (100 / 3)" :value="obj"
                                                                 :status="peonStatus(peon.deviceId)"></my-box2>
                                                    </my-canvas>
                                                </div> <!-- tooltips end -->

                                                <b-tooltip :target="'bot-status' + index" placement="bottom"
                                                           variant="danger">
                                                    <table class="table table-striped table-sm bot-status-tooltip">
                                                        <tr>
                                                            <th>CPU</th>
                                                            <td class="text-left">{{ peon.cpuUsage }} %</td>
                                                        </tr>
                                                        <tr>
                                                            <th>MEM</th>
                                                            <td class="text-left">{{ peon.memoryUsage }} MB / {{
                                                                peon.totalMemory }} MB</td>
                                                        </tr>
                                                        <tr>
                                                            <th>DISK</th>
                                                            <td class="text-left">{{ peon.diskUsage }} / {{ peon.totalDisk
                                                            }}</td>
                                                        </tr>
                                                    </table>

                                                </b-tooltip>
                                            </div>
                                            <!-- <b-tooltip v-bind:target="'tooltip' + index" variant="danger">CPU : {{ peon.cpuUsage }} <br>MEM : </b-tooltip> -->
                                        </td>
                                        <!--
              <td>{{ peon.cpuUsage }}</td>
              <td>{{ Math.round(peon.memoryUsage / peon.totalMemory * 100) }}</td>
              <td>{{ Math.round(peon.diskUsage / peon.totalDisk * 100) }}</td>
              -->

                                        <!-- <td colspan="3">
                <div id="barchart_material" style="width: 300px; height: 50px;">
                  <GChart type="BarChart" :data="chartData[index]" :options="chartOptions[index]" />
                </div>
              </td>
              <td>{{ index }}</td> -->

                                        <td align="center">
                                            <button type="button" class="btn btn-history btn-sm"
                                                    @click="showDetails(peon.deviceId)">Detail</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan='4' :v-html="getNotification(peon.deviceId)">
                                            <!-- {{ getNotification(peon.deviceId) }} -->
                                        </td>
                                    </tr>
                                </template>


                            </tbody>
                        </table>
                    </div><!--card body end-->

                </b-tab>
            </b-tabs>
        </b-card>
        <!--     <div id="botlist" class="card  shadow-sm">
      <div class="card-header">
      <h3 class="dashboard-title"><i class="fas fa-running"> Bot list
        </i></h3>
      </div>  
 -->
        <!--****** peon 상세 MODAL START ****-->

        <b-modal size="xl" ref="modalPeonDetail" header-class="detail-header"
                 :title="modalPeonDetailTitle(selectedDeviceId)" ok-only> <!-- size = xl, lg, sm -->
            <div>
                <div class="header-wrapper d-flex align-items-center justify-content-between">
                    <div v-if="peonStatus(selectedDeviceId) === 'Running'" class="text-uppercase">
                        <img src="../assets/images/gear_run.svg" alt="running" class="run-bot">
                        <!-- {{ peonStatus(selectedDeviceId) }} -->
                    </div>
                    <div v-else-if="peonStatus(selectedDeviceId) === 'Ready'" class="text-uppercase">
                        <img src="../assets/images/gear_ready.svg" alt="ready" class="ready-bot">
                        <!-- {{ peonStatus(selectedDeviceId) }} -->
                    </div>
                    <div v-else class="text-uppercase">
                        <img src="../assets/images/disconnected.svg" alt="disconnected" class="disconnected-bot">
                        <!-- {{ peonStatus(selectedDeviceId) }} -->
                    </div>
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <div class="mr-2">
                            <b>{{ selectedDevice.alias }}</b>
                            Version: {{ selectedDevice.version == null || selectedDevice.version == '' ? '< 2.0.0' :
                                selectedDevice.version }} Last HeartBeat: {{ heartBeatTimestamp(selectedDeviceId) }} Tick: {{
        selectedDevice.tick }} sec </div>
                                <div class="mb-1">
                                    <button class="btn btn-blue" v-on:click="showScreenModal()"><i
                                           class="fas fa-desktop"></i> Screen</button>
                                    <!--                     <button class="btn btn-blue" :disabled="peonStatus(selectedDeviceId) === 'Disconnected'" v-on:click="showScreenModal()"><i class="fas fa-desktop"></i> Screen</button>
 -->
                                </div>
                        </div>
                    </div>
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab id="peonDetail" title="Process" active>
                                <loading :active.sync="showProcessLoading" :can-cancel="true" :is-full-page="false">
                                </loading>
                                <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
                                    <thead class="script-header">
                                        <tr class="text-center">
                                            <th>Process</th>
                                            <th>Version</th>
                                            <th>Run</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="process in processList">
                                            <td>{{ process.processName }}</td>
                                            <td>{{ process.version }}</td>
                                            <td><button class="btn btn-sm btn-success"
                                                        :disabled="peonStatus(selectedDeviceId) !== 'Ready'"
                                                        v-on:click="runProcess(selectedDeviceId, process.processName, process.version)">Run</button>
                                            </td>
                                            <!--                                   <td class="text-center">
                                      <button class="btn btn-sm" 
                                              v-bind:class="downloadStatusClass(script)" 
                                              v-on:click="downloadScript(script)" 
                                              :disabled="downloadStatusDisable(script)">
                                        {{ downloadStatusText(script) }}
                                      </button>
                                  </td>
                                  <td>
                                      <button v-if="downloadStatusText(script) === 'Downloaded'" class="btn btn-danger btn-sm" v-on:click="deleteScript(script)">Delete</button>
                                  </td>
 -->
                                        </tr>
                                        <tr v-show="processList == null || processList.length == 0">
                                            <td class="text-center" colspan="3">다운로드 받은 프로세스가 없습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-tab>
                            <b-tab id="peonHistory" title="History">
                                <loading :active.sync="showHistoryLoading" :can-cancel="true" :is-full-page="false">
                                </loading>
                                <h5 class="card-header bg-dark">
                                    <div class="d-flex flex-row">
                                        <div style="cursor: pointer;" class="text-warning"
                                             @click="openDatepicker('historyDatepicker')">{{ selectedDate |
                                                 moment('YYYY-MM-DD') }}</div>
                                        <datepicker ref="historyDatepicker" v-model='selectedDate'
                                                    :format='datepicker.format' :highlighted='datepicker.highlighted'>
                                        </datepicker>
                                        <button type="button" class="ml-2 btn btn-blue btn-sm"
                                                @click="retrieveScriptRunningHistoryList()">Reload</button>
                                        <div class="text-white ml-5">Total Running Time: {{ totalDailyRunningSeconds |
                                            readableTime }}</div>
                                    </div>
                                </h5>
                                <table class="table table-striped table-bordered table-hover shadow-sm">
                                    <thead class="statistics-header">
                                        <tr class="text-center">
                                            <th>프로세스(버전)</th>
                                            <th>시작</th>
                                            <th>종료</th>
                                            <th>실행</th>
                                            <th>결과</th>
                                            <th>자세히</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(daily, index) in dailyList"> <!-- v-bind:key="license.deviceId" -->
                                            <td>{{ showProcessName(daily.processName, daily.version, daily.file) }}</td>
                                            <td>{{ daily.startedTime | moment('HH:mm:ss') }}</td>
                                            <td>{{ daily.finishedTime | moment('HH:mm:ss') }}</td>
                                            <td>{{ daily.runningSeconds | currency }}</td>
                                            <td>{{ daily.resultCode }}</td>
                                            <td class="text-center">
                                                <button type="button" class="btn btn-blue"
                                                        @click="triggerProcessEvent(selectedDeviceId, daily.uuid)">Detail</button>
                                            </td>
                                        </tr>
                                        <tr v-show="dailyList == null || dailyList.length == 0">
                                            <td class="text-center" colspan="6">결과가 없습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-tab>
                            <b-tab id="peonSchedule" title="Schedule">
                                <loading :active.sync="showScheduleLoading" :can-cancel="true" :is-full-page="false">
                                </loading>
                                <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
                                    <thead class="script-header">
                                        <tr class="text-center">
                                            <th>active</th>
                                            <th>type</th>
                                            <th>schedule</th>
                                            <th>file<button type="button" class="btn btn-blue"
                                                        @click="saveSchedules(selectedDeviceId)">Save Test</button></th>
                                            <th>duplication</th>
                                            <th>retry</th>
                                            <th>priority</th>
                                            <th>description</th>
                                            <th>args</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="schedule in scheduleList">
                                            <td>{{ schedule.active }}</td>
                                            <td>{{ schedule.type }}</td>
                                            <td>{{ schedule.schedule }}</td>
                                            <td>{{ schedule.file }}</td>
                                            <td>{{ schedule.duplication }}</td>
                                            <td>{{ schedule.retry }}</td>
                                            <td>{{ schedule.priority }}</td>
                                            <td>{{ schedule.description }}</td>
                                            <td>{{ schedule.args }}</td>
                                            <!-- <td>{{ schedule.file }}</td> -->
                                            <!--                                   <td><button class="btn btn-sm btn-success" :disabled="peonStatus(selectedDeviceId) !== 'Ready'" v-on:click="runProcess(selectedDeviceId, process.processName, process.version)">Run</button></td> -->
                                        </tr>
                                        <tr v-show="scheduleList == null || scheduleList.length == 0">
                                            <td class="text-center" colspan="3">스케쥴이 없습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-tab>
                            <!--                     <b-tab id="peonDetail2" title="Details2">
                        <button type="button" class="btn btn-blue" @click="triggerProcessEvent()">Detail</button>
                    </b-tab>
 -->
                        </b-tabs>
                    </b-card>


                    <!-- cpu, mem, disk 사용량 보여주는 곳인데 잘 안보여서 귀찮아서 일단 주석 처리 -->
                    <!--             <div >
                <div :id="'popup-bot-status'+ selectedDeviceId">
                    <my-canvas class="bot-status-chart" :id="'tooltip' + selectedDeviceId">
                        <my-box2
                            v-for="(obj, index) in [selectedDevice.cpuUsage, Math.round(selectedDevice.memoryUsage / selectedDevice.totalMemory * 100), Math.round(selectedDevice.diskUsage / selectedDevice.totalDisk * 100)]"
                            :x1="0"
                            :x2="obj"
                            :y1="((index / 3) * 100)"
                            :y2="((index / 3) * 100) + (100 / 3)"
                            :value="obj"
                            :status="peonStatus(selectedDeviceId)"
                        >
                        </my-box2>
                    </my-canvas>
                </div>

                <b-tooltip :target="'popup-bot-status' + selectedDeviceId" placement="bottom" variant="danger">                
                    <table class="table table-striped table-sm bot-status-tooltip">
                        <tr>
                            <th>CPU</th>
                            <td class="text-left">{{ selectedDevice.cpuUsage }} %</td>
                        </tr>
                        <tr>
                            <th>MEM</th>
                            <td class="text-left">{{ selectedDevice.memoryUsage }} MB / {{ selectedDevice.totalMemory }} MB</td>
                        </tr>
                        <tr>
                            <th>DISK</th>
                            <td class="text-left">{{ selectedDevice.diskUsage }} / {{ selectedDevice.totalDisk }}</td>
                        </tr>
                    </table>
                </b-tooltip>
            </div> -->
                </div>
        </b-modal>
        <!--****** peon 상세 MODAL END ****-->

        <!--****** SCREEN MODAL START ****-->
        <b-modal size="sm" ref="modalScriptRun" :title="scriptRunTitle(popupRunProcessName, popupRunVersion)"
                 @ok="scriptRun"> <!-- size = xl, lg, sm -->
            args[0] <input class="form-control" type="text" name="args0" v-model="args0" />
            args[1] <input class="form-control" type="text" name="args1" v-model="args1" />
            args[2] <input class="form-control" type="text" name="args2" v-model="args2" />
        </b-modal>

        <b-modal size="xl" ref="modalPeonScreen" header-class="detail-header"
                 :title="modalPeonDetailTitle(selectedDeviceId)" @hidden="hiddenScreenModal" ok-only>
            <div class="screen-info rounded shadow-sm d-flex justify-content-between">
                <loading :active.sync="showScreenshotLoading" :can-cancel="true" :is-full-page="false"></loading>
                <div>
                    <table>
                        <tr>
                            <th>
                                <i class="fas fa-desktop"> Screen size</i>
                            </th>
                            <td>&nbsp;&nbsp;<span class="font-italic">Width:</span> {{ screenshotWidth }}</td>
                            <td>&nbsp;&nbsp;<span class="font-italic">Height:</span> {{ screenshotHeight }}</td>
                        </tr>
                        <tr>
                            <th>
                                <i class="fas fa-location-arrow"> Location</i>
                            </th>
                            <td>&nbsp;&nbsp;<span class="font-italic">X:</span> {{ x }}</td>
                            <td>&nbsp;&nbsp;<span class="font-italic">Y:</span> {{ y }}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <b-button-group>
                        <b-button variant="info" @click="fetchAndShowScreenshot()"><i class="fas fa-sync-alt"></i>
                            Refresh</b-button>
                        <b-dropdown right :text="titleMonitorDropdown()">
                            <b-dropdown-item v-for="(screen, index) in screenshotInfo" @click="selectMonitor(index)">Monitor
                                {{ index }}</b-dropdown-item>
                        </b-dropdown>
                        <!-- <b-form-select right @change="reloadNotificationList($event)" v-model="levelSelected" :options="levelOptions" size="sm" class="mr-4"> -->
                        <!--                     <b-form-select v-model="selectedMonitor" class="mb-3" right>
                        <b-form-select-option>Monitor 0</b-form-select-option>
                        <b-form-select-option>Monitor 1</b-form-select-option>
                    </b-form-select> -->
                    </b-button-group>
                </div>


            </div>
            <div id="screen" v-on:mousemove="updateCoordinates" v-on:click="clickScreenshot">
                <b-img-lazy v-bind="screenProps" :src="screenshot" alt="Screenshot" class="screen"></b-img-lazy>
            </div>
            <div>
                <b-form-textarea id="textarea" v-model="logs" rows="5"></b-form-textarea>
            </div>
            <!--         <div class="mt-1">
            <button @click="disconnect">연결끊기</button>
            <button @click="connect">연결</button>
            <button @click="sendMessage">메시지 전송</button>
        </div> -->
            <div>
                <b-form-textarea id="textarea" v-model="code" placeholder="Write some code..." rows="5"></b-form-textarea>
            </div>
            <div class="mt-1">
                <b-button class="btn-purple mr-1" v-on:click="evalCode()" :disabled="code.trim() === ''">Execute</b-button>
                <b-button class="btn-success mr-1" v-on:click="clearCode()" :disabled="code.trim() === ''">Clear</b-button>

            </div>
        </b-modal>
        <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary"
                 ok-title="Close">
            <p class="my-4 text-center">{{ msgContent }}</p>
        </b-modal>
    </div>
</template>
<!--****** SCREEN MODAL END ****-->

<script>
// import { mapState } from 'vuex'

import MyCanvas from './MyCanvas.vue';
import MyBox from './MyBox.vue';
import MyBox2 from './MyBox2.vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Datepicker from 'vuejs-datepicker';

export default {
    name: 'Dashboard',
    components: {
        MyCanvas,
        MyBox,
        MyBox2,
        Loading,
        Datepicker
    },
    props: {
        msg: String
    },
    data() {
        return {
            selectedDeviceId: '',  // 팝업을 보여주기 위해 선택된 Device Id
            selectedDevice: {},
            processList: [],
            scheduleList: [],
            popupRunProcessName: '',
            popupRunVersion: '',
            args0: '',
            args1: '',
            args2: '',
            screenProps: {
                center: true,
                fluidGrow: true,
                blank: true,
                blankColor: '#bbb',
                width: 600,
                height: 400,
                class: 'my-5'
            },
            screenshot: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
            selectedMonitor: 0,
            screenshotInfo: [],
            screenshotWidth: 640,
            screenshotHeight: 480,
            x: 0,
            y: 0,
            code: '',

            logs: '',
            webSocketStatus: "disconnected",

            dailyList: [],
            totalDailyRunningSeconds: 0,

            selectedDate: new Date(),
            datepicker: {
                // date: new Date(2019, 2, 14),
                format: 'yyyy-MM-dd',
                highlighted: {
                    days: [6, 0]
                }
            },

            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: '',

            showProcessLoading: false,
            showHistoryLoading: false,
            showScheduleLoading: false,
            showScreenshotLoading: false,


        }
    },
    filters: {
        currency: function (value) {
            var num = new Number(value);

            return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        },
        readableTime: function (value) {
            if (value < 60) {
                return value + ' sec';
            } else if (value < 3600) {
                return parseInt(value / 60) + ' min ' + (value % 60) + ' sec';
            } else {
                return parseInt(value / 3600) + ' hr ' + parseInt((value % 3600) / 60) + ' min ' + (value % 60) + ' sec';
            }
        }
    },
    computed: {
        // peonList: function() {
        //     // for (var i = 0 ; i < this.$store.state.peonList.length ; i++) {
        //     //     console.log('i = ' + i + ' alias = ' + this.$store.state.peonList[i].alias + ", deviceId = " + this.$store.state.peonList[i].deviceId);
        //     // }

        //     return this.$store.getters.getPeonList;
        // },
        peonList: function () {
            return this.$store.getters.getPeonList;
        },
        selectedGroup: {
            get(){
                return this.$store.state.selectedGroup;
            },
            set(newValue){
                this.$store.commit('setSelectedGroup', newValue);
            }
        },
        groupOptions: function () {
            return this.$store.state.groupOptions;
        },
        peonSlicedList: function () {
            return function (start, end) {
                // index selectGroup 아니면 pass (i += 1)
                return this.$store.getters.getPeonList.slice(start, end);
            }
        },
        peonSlicedIndexes: function () {
            var indexes = [];
            for (var i = 0; i < this.$store.getters.getPeonList.length; i += 6) {
                // index selectGroup 아니면 pass (i += 1)
                indexes.push(i);
            }

            return indexes;
        },
        getNotification: function () {
            return function (deviceId) {
                var notification = this.$store.getters.getNotification(deviceId);

                if (notification == null) {
                    return '-';
                }

                return "<i>" + this.$moment(notification.createdDate).format('YYYY-MM-DD HH:mm:ss') + '</i> ' + notification.message;
            }
        },
        peonStatus() {
            return function (deviceId) {
                var peon = this.$store.getters.getPeon(deviceId);

                if (peon == null) {
                    return "Disconnected";
                } else {
                    return peon.status;
                }
            }
        },
        heartBeatTimestamp() {
            return function (deviceId) {
                var peon = this.$store.getters.getPeon(deviceId);

                if (peon === null) {
                    return '-';
                } else {
                    if (peon.createdDate != null) {
                        var timestamp = this.$moment(peon.createdDate);

                        var now = this.$moment(new Date());

                        if (now - timestamp > 30000) {
                            return this.$moment(peon.createdDate).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            return this.$moment(peon.createdDate).format('HH:mm:ss');
                        }
                    } else {
                        return '-';
                    }
                }
            }
        }
    },
    methods: {
        triggerProcessEvent(deviceId, uuid) {
            this.$emit('triggerProcessEvent', deviceId, uuid);
        },
        // connect() {
        //     // this.socket = new WebSocket("wss://echo.websocket.org");
        //     this.socket = new WebSocket("ws://localhost:8080/watcher");
        //     this.socket.onopen = () => {
        //         this.webSocketStatus = "connected";

        //         this.logs += "연결 완료";

        //         this.socket.onmessage = ({data}) => {
        //             this.logs += "메시지 수신 : " + data;
        //         };
        //     };
        // },
        // disconnect() {
        //     this.socket.close();
        //     this.webSocketStatus = "disconnected";
        //     this.logs = "";
        // },
        // sendMessage() {
        //     this.socket.send(this.code);
        //     this.logs += "메시지 전송 : " + this.code;
        // },
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;

            this.$bvModal.show('messageModal');
        },
        openDatepicker(datepicker) {
            if (datepicker == 'historyDatepicker') {
                this.$refs.historyDatepicker.showCalendar();
                // } else if (datepicker == 'datepicker2') {
                //     this.$refs.datepicker2.showCalendar();
                // } else if (datepicker == 'fromDatePicker') {
                //     this.$refs.fromDatePicker.showCalendar();
                // } else if (datepicker == 'toDatePicker') {
                //     this.$refs.toDatePicker.showCalendar();
            }
        },

        clearCode() {
            this.code = "";
        },
        evalCode() {
            axios.post('/peon/command', { 'command': 'eval', 'deviceId': this.selectedDeviceId, 'code': this.code }, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.fetchAndShowScreenshot();
            });
        },
        showDetails(deviceId) {
            this.selectedDeviceId = deviceId;
            this.selectedDevice = this.$store.getters.getPeon(deviceId);

            var params = {
                'deviceId': deviceId
            };

            this.processList = [];

            this.showProcessLoading = true;

            axios.get('peon/retrieveProcessList', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.processList = response.data.body.list;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.showProcessLoading = false;
            });

            this.retrieveScriptRunningHistoryList();
            this.retrieveScheduleList(deviceId);

            this.$refs['modalPeonDetail'].show();
        },
        retrieveScriptRunningHistoryList() {
            var params = {};

            params.deviceId = this.selectedDeviceId;
            params.date = this.$moment(this.selectedDate).format('YYYY-MM-DD');

            this.showHistoryLoading = true;

            axios.post('peon/retrieveScriptRunningHistoryList', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.totalDailyRunningSeconds = response.data.body.totalRunningSeconds;
                this.dailyList = response.data.body.list;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.showHistoryLoading = false;
            });
        },
        retrieveScheduleList(deviceId) {
            this.selectedDeviceId = deviceId;
            this.selectedDevice = this.$store.getters.getPeon(deviceId);

            var params = {
                'deviceId': deviceId
            };

            this.scheduleList = [];

            this.showScheduleLoading = true;

            axios.post('/peon/command', { 'command': 'sendSchedule', 'deviceId': this.selectedDeviceId }, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.scheduleList = response.data.body.list;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.showScheduleLoading = false;
            });
        },
        saveSchedules(deviceId) {
            this.selectedDeviceId = deviceId;

            axios.post('/peon/command', { 'command': 'saveSchedule', 'deviceId': this.selectedDeviceId }, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                console.log("success");
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            });
        },
        showProcessName(processName, version, file) {
            if (processName == null || processName == '') {
                var strs = file.split('\\');

                if (strs == null || strs.length == 0) {
                    return file;
                } else {
                    return strs[strs.length - 1];
                }
            } else {
                return processName + '(' + version + ')';
            }
        },
        modalPeonDetailTitle(deviceId) {
            return this.$store.getters.getPeonAlias(deviceId) + " (" + deviceId + ")";
            // return deviceId + " (alias)";
        },
        titleMonitorDropdown() {
            if (this.screenshotInfo == null || this.screenshotInfo.length == 0) {
                return "Select Monitor";
            }

            return "Monitor " + this.selectedMonitor;
        },
        selectMonitor(index) {
            if (this.selectedMonitor !== index) {
                this.selectedMonitor = index;

                this.showScreenshot(this.selectedDeviceId);
            }
        },
        updateCoordinates: function (event) {
            // this.x = event.offsetX;
            // this.y = event.offsetY;

            let width = document.getElementById('screen').clientWidth - 8;  // 8을 빼는 이유는 좌, 우 padding 4씩
            let height = document.getElementById('screen').clientHeight - 8;

            // 아래 x, y를 offset 값으로 사용하지 않고 보정하는 이유는 padding 때문
            var x = event.offsetX;
            if (x < 0) {
                x = 0;
            }
            if (x >= width) {
                x = width - 1;
            }

            var y = event.offsetY;
            if (y < 0) {
                y = 0;
            }
            if (y >= height) {
                y = height - 1;
            }

            this.x = Math.round(this.screenshotWidth * 1.0 / width * x);
            this.y = Math.round(this.screenshotHeight * 1.0 / height * y);

            // console.log('screen ' + width + ', ' + height);
            // console.log('offset ' + event.offsetX + ', ' + event.offsetY);
        },
        clickScreenshot: function (event) {
            this.code += 'Mouse.move(' + this.selectedMonitor + ', ' + this.x + ', ' + this.y + ');\n';
        },
        showScreenModal() {
            this.selectedMonitor = 0;
            this.screenshot = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

            this.fetchAndShowScreenshot();

            this.$refs['modalPeonScreen'].show();

            // 아래처럼 해도 된다는 말이 있었으나 안됨..
            // window.document.cookie = 'authorization=' + accessToken() + '; path=/';

            // this.socket = new WebSocket("ws://localhost:8080/watcher");
            // this.socket.onopen = () => {
            //     this.webSocketStatus = "connected";

            //     var initMessage = {
            //         "deviceId": this.selectedDeviceId,
            //         "version": "1.0.0"
            //     };

            //     // this.logs += "연결 완료";
            //     this.socket.send(JSON.stringify(initMessage));

            //     this.socket.onmessage = ({data}) => {
            //         this.logs += data;
            //     };
            // };

            axios.get('peon/authenticateWatcher', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.socket = new WebSocket(WORKMAN_WS + "watcher");
                this.socket.onopen = () => {
                    this.webSocketStatus = "connected";

                    var initMessage = {
                        "accessToken": accessToken(),
                        "deviceId": this.selectedDeviceId,
                        "version": "1.0.0"
                    };

                    // this.logs += "연결 완료";
                    this.socket.send(JSON.stringify(initMessage));

                    this.socket.onmessage = ({ data }) => {
                        this.logs += data;
                    };
                };
            });
        },
        hiddenScreenModal() {
            this.socket.close();
            this.webSocketStatus = "disconnected";
            this.logs = "";
        },
        fetchAndShowScreenshot() {
            this.showScreenshotLoading = true;

            var params = {
                'command': 'sendScreenshot',
                'deviceId': this.selectedDeviceId
            };

            axios.post('peon/command', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.screenshotInfo = response.data.body.list;

                this.showScreenshot();
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.showScreenshotLoading = false;
            });
        },
        showScreenshot() {
            this.showScreenshotLoading = true;

            this.screenshotWidth = this.screenshotInfo[this.selectedMonitor].width;
            this.screenshotHeight = this.screenshotInfo[this.selectedMonitor].height;

            var params = {
                'deviceId': this.selectedDeviceId,
                'screenshot': this.screenshotInfo[this.selectedMonitor].screenshot
            };

            axios({
                method: 'get',
                url: 'peon/retrieveScreenshot',
                params: params,
                responseType: 'blob',
                headers: {
                    'Content-type': 'image/png',
                    'Authorization': accessToken()
                }
            }).then(response => {
                let reader = new FileReader();
                reader.readAsDataURL(response.data);
                reader.onload = () => {
                    this.screenshot = reader.result;
                }
            }).catch(error => {
                if (error.status != 401) {
                    // this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    // 여긴 blob 이라 그냥 내 맘대로 메시지를 보여줌
                    this.showMessage(error.status, this.screenshotInfo[this.selectedMonitor].screenshot + " 파일을 찾을 수 없습니다.");
                }
            }).finally(() => {
                this.showScreenshotLoading = false;
            });
        },
        runProcess(deviceId, processName, version) {
            this.popupRunProcessName = processName;
            this.popupRunVersion = version;

            this.$refs['modalScriptRun'].show();
        },
        scriptRunTitle(processName, version) {
            return processName + " (" + version + ")";
        },
        scriptRun(bvModalEvt) {
            // alert('run the script' + this.$store.state.scriptList[this.popupRunIndex].processName);

            var params = {
                'command': 'run',
                'deviceId': this.selectedDeviceId,
                'processName': this.popupRunProcessName,
                'version': this.popupRunVersion,
            };

            var args = [];
            if (this.args0 != null && this.args0.trim().length > 0) {
                args.push(this.args0.trim());
            }

            if (this.args1 != null && this.args1.trim().length > 0) {
                args.push(this.args1.trim());
            }

            if (this.args2 != null && this.args2.trim().length > 0) {
                args.push(this.args2.trim());
            }

            if (args.length > 0) {
                params.args = args;
            }

            axios.post('peon/command', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(() => {
                this.args0 = '';
                this.args1 = '';
                this.args2 = '';
            });
        },
        async reloadPeonList() {
            await this.$store.dispatch('reloadGroupPeonList', this.selectedGroup);
            await this.$store.dispatch('retrieveLatestData');
        }
    },
    beforeDestroy(){
        this.selectedGroup = '';
        this.reloadPeonList();
    }
}

// 아래 함수는 moment로 대체함
// function getTimestampString(time) {
//     var timestamp = new Date(time);

//     var year = timestamp.getFullYear();
//     var month = timestamp.getMonth() + 1;
//     if (month < 10) {
//         month = '0' + month;
//     }
//     var date = timestamp.getDate();
//     if (date < 10) {
//         date = '0' + date;
//     }

//     var hours = timestamp.getHours();
//     if (hours < 10) {
//         hours = '0' + hours;
//     }

//     var minutes = timestamp.getMinutes();
//     if (minutes < 10) {
//         minutes = '0' + minutes;
//     }

//     var seconds = timestamp.getSeconds();
//     if (seconds < 10) {
//         seconds = '0' + seconds;
//     }

//     return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.bot-detail {
    text-decoration: none;
    color: black;
}

.modal-fullscreen1 .modal {
    padding: 0 !important;
}

.modal-fullscreen1 .modal-dialog {
    max-width: 100%;
    height: 100%;
    margin: 0;
}

.modal-fullscreen1 .modal-content {
    border: 0;
    border-radius: 0;
    min-height: 100%;
    height: auto;
}

.modal-fullscreen2 .modal {
    padding: 0 !important;
}

.modal-fullscreen2 .modal-dialog {
    max-width: 100%;
    height: 100%;
    margin: 0;
}

.modal-fullscreen2 .modal-content {
    width: calc(100% - 2rem);
    min-height: 100%;
    height: auto;
    margin: 1rem;
}

.screen-info {
    background: rgba(227, 233, 53, 0.5);
    color: black;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
}

.screen {
    border: 4px solid #564C8B;
    border-radius: 5px;
    box-shadow: 3px 3px 5px #888888;
}
</style>